var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showCardPesquisa
        ? _c(
            "q-card",
            [
              _c(
                "q-card-main",
                [
                  _c(
                    "q-collapsible",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBuscaAvancada,
                          expression: "showBuscaAvancada"
                        }
                      ],
                      staticClass: "gvn-collapse-filtro",
                      attrs: {
                        icon: "fa fa-filter",
                        opened: _vm.showBuscaAvancadaAberta,
                        label: "Pesquisa avançada"
                      }
                    },
                    [_vm._t("default")],
                    2
                  ),
                  _c("div", { staticClass: "row title" }, [
                    _vm.showTermoPesquisa
                      ? _c(
                          "div",
                          { staticClass: "termo" },
                          [
                            _c("q-search", {
                              staticClass: "gvn-q-search",
                              attrs: {
                                placeholder: "Pesquisar",
                                debounce: 1,
                                "max-length": _vm.tamanhoTermoPesquisa,
                                clearable: false
                              },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !("button" in $event) &&
                                    $event.keyCode !== 13
                                  ) {
                                    return null
                                  }
                                  _vm.pesquisarTermo()
                                }
                              },
                              model: {
                                value: _vm.termo,
                                callback: function($$v) {
                                  _vm.termo = $$v
                                },
                                expression: "termo"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBotoesPesquisa,
                          expression: "showBotoesPesquisa"
                        }
                      ],
                      staticClass: "row mrg-t-10"
                    },
                    [
                      _vm.validarAntesDePesquisar
                        ? _c(
                            "div",
                            { staticClass: "col-6 text-left" },
                            [
                              _c(
                                "q-btn",
                                {
                                  staticStyle: {
                                    background: "#550059 !important",
                                    color: "white"
                                  },
                                  attrs: { icon: "fa fa-search" },
                                  on: { click: _vm.pesquisarAposValidar }
                                },
                                [
                                  _vm._v(
                                    "\n              Pesquisar\n          "
                                  )
                                ]
                              ),
                              _vm._v("\n            \n          "),
                              _c(
                                "q-btn",
                                {
                                  attrs: { icon: "fa fa-eraser" },
                                  on: { click: _vm.limparFiltros }
                                },
                                [_vm._v("\n              Limpar\n          ")]
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "col-6 text-left" },
                            [
                              _c(
                                "q-btn",
                                {
                                  staticStyle: {
                                    background: "#550059 !important",
                                    color: "white"
                                  },
                                  attrs: { icon: "fa fa-search" },
                                  on: { click: _vm.pesquisar }
                                },
                                [
                                  _vm._v(
                                    "\n              Pesquisar\n          "
                                  )
                                ]
                              ),
                              _vm._v("\n            \n          "),
                              _c(
                                "q-btn",
                                {
                                  attrs: { icon: "fa fa-eraser" },
                                  on: { click: _vm.limparFiltros }
                                },
                                [_vm._v("\n              Limpar\n          ")]
                              )
                            ],
                            1
                          ),
                      _vm.showImprimirENovo
                        ? _c(
                            "div",
                            { staticClass: "col-6 text-right" },
                            [
                              _vm.showBtnAdicional
                                ? _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        icon: _vm.btnAdicionalIcone,
                                        color: _vm.btnAdicionalCor
                                      },
                                      on: { click: _vm.btnAdicionalFuncao }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.btnAdicionalDescricao) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.showBtnAdicional ? " " : "") +
                                  "\n          "
                              ),
                              _c(
                                "q-btn-dropdown",
                                {
                                  attrs: {
                                    icon: "fa fa-file-export",
                                    label: "Exportar"
                                  }
                                },
                                [
                                  _c(
                                    "q-list",
                                    { attrs: { link: "" } },
                                    [
                                      _c(
                                        "q-item",
                                        {
                                          attrs: { clickable: "" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.exportarCsv($event)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "q-item-main",
                                            [
                                              _c(
                                                "q-item-tile",
                                                { attrs: { label: "" } },
                                                [_vm._v("CSV")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "q-item",
                                        {
                                          attrs: { clickable: "" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.exportarHtml($event)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "q-item-main",
                                            [
                                              _c(
                                                "q-item-tile",
                                                { attrs: { label: "" } },
                                                [_vm._v("HTML")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v("\n           \n          "),
                              _vm.novo !== null && _vm.showBotaoNovo
                                ? _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        icon: "fa fa-plus",
                                        color: "primary"
                                      },
                                      on: { click: _vm.novoF }
                                    },
                                    [_vm._v("\n              Novo\n          ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { height: "1px !important" } },
                [
                  _c("q-progress", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.progresso,
                        expression: "progresso"
                      }
                    ],
                    attrs: { indeterminate: true }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mrg-t-0" },
        [
          _c("g-datatable", {
            ref: "refPesquisaResultado",
            attrs: {
              colunas: _vm.colunasPropriedade,
              colunasExpansao: _vm.colunasExpansao,
              operacoes: _vm.operacoes,
              operacoesQFab: _vm.operacoesQFab,
              api: _vm.apiPesquisa,
              apiRelatorio: _vm.apiRelatorio,
              getFiltroPesquisa: _vm.getFiltros,
              elementosPorPagina: _vm.elementosPorPagina,
              exibirColunaOperacoes: _vm.exibirColunaOperacoes,
              exibirColunaOperacoesQFab: _vm.exibirColunaOperacoesQFab,
              confVisualizar: _vm.confVisualizar,
              confEditar: _vm.confEditar,
              confExcluir: _vm.confExcluir,
              carregamentoInicial: _vm.carregamentoInicial,
              scrollHorizontal: _vm.scrollHorizontal,
              acaoPosPesquisa: _vm.acaoPosPesquisa
            },
            model: {
              value: _vm.pagina,
              callback: function($$v) {
                _vm.pagina = $$v
              },
              expression: "pagina"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }